import get from 'lodash/get';
import { TYPES } from './actions';
import { merge } from '../../../utils/state';

const initialState = {
  isVisible: false,
  message: null,
  variant: null,
  persist: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET_NOTIFICATION:
      return merge(state, {
        isVisible: true,
        message: get(action, 'payload.message', null),
        variant: get(action, 'payload.variant', null),
        startIcon: get(action, 'payload.startIcon', null),
        persist: get(action, 'payload.persist', false),
      });
    case TYPES.CLEAR_NOTIFICATION:
      return merge(state, {
        isVisible: false,
        message: null,
        variant: null,
        startIcon: null,
        persist: false,
      });
    default:
      return state;
  }
};

export default reducer;
